<template>
  <div class="form__field" :class="`--${size}`">
    <label :for="name" class="label">
      <span>{{ label }}</span>
      <span v-if="required" class="required-symbol">*</span>
    </label>
    <div class="select-container">
      <select :id="name" :name="name" @input="change">
        <option value="0">{{ $t(`form.placeholder.${name}`) }}</option>
        <option v-for="option in options" :key="option.key" :value="option.key"
          :selected="modelValue.value == option.key">
          {{ option.value }}
        </option>
      </select>
    </div>
    <p v-if="message" class="note">
      {{ message }}
    </p>
    <p :class="['input-error', { '--hidden': !(!modelValue.valid && onFocus) }]">
      {{ $t(`form.errors.${name}`) }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'FormSelect',
  props: {
    label: {
      type: String,
      required: true
    },
    message: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      onFocus: false
    }
  },
  methods: {
    change(event) {
      this.onFocus = true
      this.$emit('update:modelValue', {
        value: event.target.value,
        valid: !this.required ? true : event.target.value && event.target.value !== '0'
      })
    }
  },
  mounted() {
    this.$emit('update:modelValue', {
      value: this.modelValue.value,
      valid: !this.required ? true : this.modelValue.value && this.modelValue.value !== '0'
    })
  }
}
</script>